// src/components/editor/CollabTabs.jsx
//
// Switches the Collab panel between the comment index and the collaborator
// roster. Both are peers, so they get a segmented control rather than one
// hiding behind a back arrow on the other — a back arrow reads as "up a
// level", and the editor's icon strip is already the only place that navigates.
//
// Plain Boxes, not MUI Buttons: the panel container ships global CSS that
// forces any MuiButton to full width with gold styling.
import React from 'react';
import { Box } from '@mui/material';

const GOLD = '#F5D76E';
const PURPLE = '#4A3F8C';

const TABS = [
  { id: 'comments', label: 'Comments' },
  { id: 'people', label: 'People' },
];

export default function CollabTabs({ value, onChange }) {
  return (
    <Box
      role="tablist"
      aria-label="Collaboration views"
      sx={{
        display: 'flex',
        gap: 0.5,
        p: 0.5,
        m: 1,
        mb: 0.5,
        borderRadius: '8px',
        backgroundColor: 'rgba(0,0,0,0.22)',
        flexShrink: 0,
      }}
    >
      {TABS.map((t) => {
        const active = value === t.id;
        return (
          <Box
            key={t.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange?.(t.id)}
            sx={{
              flex: 1,
              font: 'inherit',
              fontSize: 12.5,
              fontWeight: 700,
              py: 0.85,
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'background-color .12s ease, color .12s ease',
              color: active ? PURPLE : 'rgba(255,255,255,0.75)',
              backgroundColor: active ? GOLD : 'transparent',
              '&:hover': {
                backgroundColor: active ? GOLD : 'rgba(245,215,110,0.15)',
              },
              '&:focus-visible': { outline: `2px solid ${GOLD}`, outlineOffset: '1px' },
            }}
          >
            {t.label}
          </Box>
        );
      })}
    </Box>
  );
}
